import React from "react";
import { useSelector } from "react-redux";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import DatePicker from "./DatePicker";
import Scorecards from "./Scorecards";
import RiskFilter from "./RiskFilter";
import RiskMembersTable from "./RiskMembersTable";
import { DataPoints } from "./DataPoints";

const PredictionView = () => {
  const {
    updatesLoading,
    scorecards,
    table: { data = [] }
  } = useSelector((state) => state.riskMembers);

  return (
    <div>
      <div
        id="override-edit-selection-bar"
        className="dropdown dropdown-actions actions"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          marginBottom: 30
        }}
      >
        <div className="filters-wrapper" style={{ display: "flex" }}>
          <div className="select-box" style={{ width: 170, marginRight: 15 }}>
            <p>Risk Level</p>
            <RiskFilter />
          </div>
        </div>
        <DatePicker />
      </div>
      {updatesLoading ? <LoadingAnimation uiLoader /> : data.length ? <DataPoints /> : null}
      <div data-testid="charts-container" className="chart-root">
        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : (
          <>
            {scorecards.length ? <Scorecards scorecards={scorecards} /> : null}
            <RiskMembersTable />
          </>
        )}
      </div>
    </div>
  );
};

export default PredictionView;
